module.exports = __webpack_public_path__ + "media/images/man-profile-2-cd5acc55a115052507547157cd7d2d3c.jpeg";